module.exports = __webpack_public_path__ + "img/4fc10e77ca42b334cd028de730c15a38.png";